import { RUSTORE_APP_URL } from '../lib/appLinks'
import { RuStoreBadge } from './logist-story/RuStoreBadge'
import './rustore-download-link.css'

export function RuStoreDownloadLink({ className = '', onClick }: { className?: string; onClick?: () => void }) {
  return (
    <a
      className={`rustore-download-link ${className}`.trim()}
      href={RUSTORE_APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <RuStoreBadge />
    </a>
  )
}
